module.exports = __webpack_public_path__ + "img/icon-bell-notice.1678b1cb.svg";